const isEnumValue = <T extends Record<string, string | number>>(
  enumObject: T,
  value: unknown,
): value is T[keyof T] => {
  const values = Object.values(enumObject);

  if (typeof value === 'number') {
    return values.some((v) => typeof v === 'number' && v === value);
  }

  if (typeof value === 'string') {
    if (value in enumObject) {
      return false;
    }

    return values.some((v) => typeof v === 'string' && v === value);
  }

  return false;
};

export default isEnumValue;
